import {
    BDCheckboxFilter,
    BDCheckboxFilterCategory,
    BDFilter,
    BDFilterCategory,
    BDFilterDeviceCategory,
    BDRadioFilter,
    BDRadioFilterCategory,
    BDSliderFilter,
    BDSliderFilterCategory,
    BDUtilityService
} from '@brother-apps/brother-dealerapp-shared-lib';
import {Component, OnInit} from '@angular/core';

import {BDCPFilterService} from '../../services/filter.service';
import {BDCPShareService} from '../../../shared/services/share.service';

@Component({
    selector: 'bdcp-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
export class BDCPFilterComponent implements OnInit {

    public isActive = false;

    public selectedDeviceCategory: BDFilterDeviceCategory;
    public deviceCategories: BDFilterDeviceCategory[] = [];

    private oldOverflow: string;

    public constructor(
        public utility: BDUtilityService,
        private filterService: BDCPFilterService,
        private share: BDCPShareService,
    ) {
    }

    public ngOnInit(): void {
        this.initDeviceCategories();
    }

    public open(): void {
        this.reset();
        this.oldOverflow = document.body.style['overflow'];
        document.body.style['overflow'] = 'hidden';
        this.isActive = true;
    }

    public close(): void {
        document.body.style['overflow'] = this.oldOverflow;
        this.isActive = false;
    }

    public requestCallback(): void {
        window.location.href = this.utility.requestCallback(
            this.share.sharedModel.name,
            this.share.sharedModel.firstname,
            this.share.sharedModel.email,
            this.share.sharedModel.salutation,
            this.share.sharedModel.relatedContactEmail,
            'Sales App: Produktsuche-Anfrage'
        );
    }

    public showResults(): void {
        const filters: BDFilter[] = [];
        filters.push(new BDFilter(this.selectedDeviceCategory.name, 'productCategory'));
        for (const filterCategory of this.selectedDeviceCategory.filterCategories) {
            for (const filter of filterCategory.filters) {
                if (filter.selected) {
                    filters.push(filter);
                }
            }
        }
        this.filterService.setFilters(filters);
        this.close();
        this.filterService.searchByFilters();
    }

    public reset(): void {
        this.selectedDeviceCategory = undefined;

        for (const deviceCategory of this.deviceCategories) {
            deviceCategory.selected = false;
        }

        this.initDeviceCategories();
    }

    public categorySelected(category: BDFilterDeviceCategory): void {
        this.selectedDeviceCategory = !category
            ? undefined
            : category.selected
                ? category
                : undefined;

        for (const deviceCategory of this.deviceCategories) {
            deviceCategory.selected = category.selected && deviceCategory.name === category.name;
        }
    }

    private initDeviceCategories(): void {
        this.deviceCategories = [];

        this.deviceCategories.push(this.initScanCategory('Scanner', 'assets/images/Kategorie-Bild_Scanner ADS4_CG_Images_4900W_front_reflection.png'));
        this.deviceCategories.push(this.initPrinterCategory('Drucker', 'assets/images/Kategorie-Bild-Drucken_PRT2_HL-L9470CDN_front_reflection.png'));
        this.deviceCategories.push(this.initMFCCategory('Multifunktionsgeräte', 'assets/images/Kategorie-Bild-Multifunktionsgerate_MFC-J6957DW_front.png')); // MFC/DCP
        this.deviceCategories.push(this.initLabelingDeviceCategory('Beschriftungsgeräte', 'assets/images/Beschriftung_PT-D610BT_Front.png'));
        this.deviceCategories.push(this.initFaxDeviceCategory('Faxgeräte', 'assets/images/cat_img-faxen.png'));

    }

    //#region BEGIN SCAN FILTERS

    private initScanCategory(name: string, imageSource: string): BDFilterDeviceCategory {
        const categories: BDFilterCategory<BDFilter>[] = [];

        categories.push(this.initScanDailyScanVolume());
        categories.push(this.initScanPaperFeedFilters());
        categories.push(this.initScanPorts());
        categories.push(this.initScanScanTargets());
        categories.push(this.initScanFileFormats());
        categories.push(this.initScanMandatoryFunctions());

        const deviceCategory = new BDFilterDeviceCategory();

        deviceCategory.name = name;
        deviceCategory.internalName = 'scanner';
        deviceCategory.imageSource = imageSource;
        deviceCategory.filterCategories = categories;

        return deviceCategory;
    }

    private initScanDailyScanVolume(): BDFilterCategory<BDSliderFilter> {
        const filters: BDSliderFilter[] = [];

        filters.push(new BDSliderFilter(500, 'minScanVolume', '500', '500'));
        filters.push(new BDSliderFilter(1500, 'minScanVolume', '1500', '1500'));
        filters.push(new BDSliderFilter(3000, 'minScanVolume', '3000', '3000'));
        filters.push(new BDSliderFilter(6000, 'minScanVolume', '6000', '6000'));

        const category = new BDSliderFilterCategory();

        category.label = 'Tägliches Scanvolumen';
        category.title = 'Minimum';
        category.distributeEvenly = true;
        category.fill = 'RTL';
        category.filters = filters;
        // category.filterDisplayValueFn = (c, v) => `Tägl. Scanvolumen: min. ${v}`;

        return category;
    }

    private initScanPaperFeedFilters(): BDFilterCategory<BDRadioFilter> {


        const filters: BDSliderFilter[] = [];


        for (let i = 1; i < 21; i++) {
            filters.push(
                new BDSliderFilter(
                    i, // VALUE
                    'minScanVolume',
                    i === 1 || i === 20 ? i.toString() : '', // LEGEND
                    i.toString(), // LABEL
                    undefined, // PERCENTAGE
                    i !== 1 && i !== 20
                )
            );
        }
        const category = new BDSliderFilterCategory();

        category.label = 'Papiereinzug';
        category.title = 'Maximum';
        category.distributeEvenly = true;
        category.fill = 'LTR';
        category.filters = filters;

        return category;
    }

    private initScanPorts(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('USB Anschluss', 'connections'));
        filters.push(new BDCheckboxFilter('WLAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('LAN Schnittstelle', 'connections'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Anschlussoptionen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initScanScanTargets(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('Lokaler PC (Dateiordner)', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('USB-Stick / Speichermedium', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Speicherkarte', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Bildeditor (z. B. Photoshop)', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Texteditor (z. B. Word)', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('E-Mail Anhang (über PC)', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Freigegebener Ordner (SMB)', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('FTP-Server', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('E-Mail Server (POP3)', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('MS-SharePoint', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Cloud-Dienste', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('iPhone', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Android', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Windows Phone', 'scanToFunctions'));
        filters.push(new BDCheckboxFilter('Drucker', 'scanToFunctions'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Scan-Ziele';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initScanFileFormats(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('PDF', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('TIFF', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('JPEG', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('TIFF_MULTIPLE', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('PNG', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('Durchsuchbares PDF', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('Komprimiertes PDF', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('Sicheres PDF', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('Passwortgeschütztes PDF', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('XPS', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('DOCX', 'scanToPcFormats'));
        filters.push(new BDCheckboxFilter('PPTX', 'scanToPcFormats'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Dateiformate (PC-Scan)';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initScanMandatoryFunctions(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('Scannen über Taste am Gerät', 'oneTouchFunction'));
        filters.push(new BDCheckboxFilter('Touchscreen-Benutzerführung', 'scanTouchScreen'));
        filters.push(new BDCheckboxFilter('Duplex', 'scanDuplex'));
        filters.push(new BDCheckboxFilter('Automatische Formaterkennung', 'automaticFormatRecognition'));
        filters.push(new BDCheckboxFilter('Ultraschall Einzugserkennung', 'paperFeedViaUltrasound'));
        filters.push(new BDCheckboxFilter('Automatische Seitenbegradigung', 'sideStraightening'));
        filters.push(new BDCheckboxFilter('OCR-Texterkennung', 'scanOcr'));
        filters.push(new BDCheckboxFilter('Automatische Bilddrehung', 'imageRotation'));
        filters.push(new BDCheckboxFilter('Leere Seiten überspringen', 'skipEmptyPage'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Benötigte Funktionen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    //#endregion END SCAN FILTERS

    //#region BEGIN PRINTER FILTERS

    private initPrinterCategory(name: string, imageSource: string): BDFilterDeviceCategory {
        const categories: BDFilterCategory<BDFilter>[] = [];

        const deviceCategory = new BDFilterDeviceCategory();

        deviceCategory.name = name;
        deviceCategory.internalName = 'printer';
        deviceCategory.imageSource = imageSource;
        deviceCategory.filterCategories = categories;

        categories.push(this.initPrinterTechnology());
        categories.push(this.initPrinterMonthlyPrintVolume());
        categories.push(this.initPrinterMinimumPrintSpeed());
        categories.push(this.initPrinterMainFunctions());
        categories.push(this.initPrinterPorts());
        categories.push(this.initPrinterPaperFormats());
        categories.push(this.initPrinterPaperFeedCount());
        categories.push(this.initPrinterExtendedGuarantees());
        categories.push(this.initPrinterLanguage());

        return deviceCategory;
    }

    private initPrinterTechnology(): BDFilterCategory<BDRadioFilter> {
        const filters: BDRadioFilter[] = [];

        filters.push(new BDRadioFilter('Laser', 'printTechnology'));
        filters.push(new BDRadioFilter('Tinte', 'printTechnology'));

        const category = new BDRadioFilterCategory();

        category.label = 'Technologie';
        category.type = 'radio';
        category.filters = filters;

        return category;
    }

    private initPrinterMonthlyPrintVolume(): BDFilterCategory<BDSliderFilter> {
        const filters: BDSliderFilter[] = [];

        for (let i = 3; i < 21; i++) {
            filters.push(
                new BDSliderFilter(
                    i * 500, // VALUE
                    'printVolumeOpt',
                    i === 3 || i === 20 ? (i * 500).toString() : '', // LEGEND
                    (i * 500).toString(), // LABEL
                    ((i - 3) * 4.515 + 6.72) / 100 // PERCENTAGE
                )
            );
        }

        filters.push(new BDSliderFilter(20000, 'printVolumeOpt', '20000', '20000', 1));

        const category = new BDSliderFilterCategory();

        category.label = 'Monatliches Druckvolumen';
        category.title = 'Seiten pro Monat';
        category.distributeEvenly = false;
        category.fill = 'NONE';
        category.filters = filters;

        return category;
    }

    private initPrinterMinimumPrintSpeed(): BDFilterCategory<BDSliderFilter> {
        const filters: BDSliderFilter[] = [];

        for (let i = 18; i < 101; i++) {
            filters.push(
                new BDSliderFilter(
                    i, // VALUE
                    'minPrintSpeed',
                    i === 18 || i === 100 ? i.toString() : '', // LEGEND
                    i.toString(), // LABEL
                    undefined, // PERCENTAGE
                    i !== 18 && i !== 100
                )
            );
        }

        const category = new BDSliderFilterCategory();

        category.label = 'Minimale Druckgeschwindigkeit';
        category.title = 'Seiten pro Minute';
        category.distributeEvenly = true;
        category.fill = 'RTL';
        category.filters = filters;

        return category;
    }

    private initPrinterMainFunctions(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('Farbdruck', 'funcColorPrint'));
        filters.push(new BDCheckboxFilter('Duplex-Druck', 'duplexPrint'));
        filters.push(new BDCheckboxFilter('Touch-Display', 'touchDisplay'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Hauptfunktionen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initPrinterPorts(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('USB Anschluss', 'connections'));
        filters.push(new BDCheckboxFilter('WLAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('LAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('Wi-Fi Direct', 'connections'));
        filters.push(new BDCheckboxFilter('Parallel Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('GIGABIT LAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('NFC', 'connections'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Anschlussoptionen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initPrinterPaperFormats(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('A4', 'printFormats'));
        filters.push(new BDCheckboxFilter('A5', 'printFormats'));
        filters.push(new BDCheckboxFilter('A6', 'printFormats'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Papierformate';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initPrinterPaperFeedCount(): BDFilterCategory<BDRadioFilter> {
        const filters: BDRadioFilter[] = [];

        filters.push(new BDRadioFilter('1', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('2', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('3', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('4', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('5', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('6', 'minTotalPaperFeedNum'));

        const category = new BDRadioFilterCategory();

        category.label = 'Anzahl Papierzufuhren';
        category.type = 'radio';
        category.filters = filters;

        return category;
    }

    private initPrinterExtendedGuarantees(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('3 Jahre vor Ort', 'warrantyOnSite3Years'));
        filters.push(new BDCheckboxFilter('PrintAirBag', 'printAirbag'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Erweiterte Garantieleistungen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initPrinterLanguage(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('PCL6 Emulation', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('PostScript', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('IBM ProPrinter XL', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('Epson FX-850', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('XPS 1.0', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('PDF 1.7', 'printerLanguages'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Druckersprache';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    //#endregion END PRINTER FILTERS

    //#region BEGIN MFC FILTERS

    private initMFCCategory(name: string, imageSource: string): BDFilterDeviceCategory {
        const categories: BDFilterCategory<BDFilter>[] = [];

        const deviceCategory = new BDFilterDeviceCategory();

        deviceCategory.name = name;
        deviceCategory.internalName = 'mfc';
        deviceCategory.imageSource = imageSource;
        deviceCategory.filterCategories = categories;

        categories.push(this.initMFCTechnology());
        categories.push(this.initMFCMonthlyPrintVolume());
        categories.push(this.initMFCMinimumPrintSpeed());
        categories.push(this.initMFCMainFunctions());
        categories.push(this.initMFCPorts());
        categories.push(this.initMFCPaperFormats());
        categories.push(this.initMFCPaperFeedCount());
        categories.push(this.initMFCDailyScanVolume());
        categories.push(this.initMFCExtendedGuarantees());
        categories.push(this.initMFCLanguage());

        return deviceCategory;
    }

    private initMFCTechnology(): BDFilterCategory<BDRadioFilter> {
        const filters: BDRadioFilter[] = [];

        filters.push(new BDRadioFilter('Laser', 'printTechnology'));
        filters.push(new BDRadioFilter('Tinte', 'printTechnology'));

        const category = new BDRadioFilterCategory();

        category.label = 'Technologie';
        category.type = 'radio';
        category.filters = filters;

        return category;
    }

    private initMFCMonthlyPrintVolume(): BDFilterCategory<BDSliderFilter> {
        const filters: BDSliderFilter[] = [];

        filters.push(new BDSliderFilter(
            150,
            'printVolumeOpt',
            '150',
            '150',
            6.72 / 100
        ));

        for (let i = 1; i < 21; i++) {
            filters.push(
                new BDSliderFilter(
                    i * 50, // VALUE
                    'printVolumeOpt',
                    i * 50 === 1000 || i * 50 === 1000 ? (i * 50).toString() : '', // LEGEND
                    (i * 50).toString(), // LABEL
                    (i * 4.664 + 6.72) / 100 // PERCENTAGE
                )
            );
        }

        const category = new BDSliderFilterCategory();

        category.label = 'Monatliches Druckvolumen';
        category.title = 'Seiten pro Monat';
        category.distributeEvenly = false;
        category.fill = 'NONE';
        category.filters = filters;

        return category;
    }

    private initMFCMinimumPrintSpeed(): BDFilterCategory<BDSliderFilter> {
        const filters: BDSliderFilter[] = [];

        for (let i = 10; i < 51; i++) {
            filters.push(
                new BDSliderFilter(
                    i, // VALUE
                    'minPrintSpeed',
                    i === 10 || i === 50 ? i.toString() : '', // LEGEND
                    i.toString(), // LABEL
                    undefined, // PERCENTAGE
                    i !== 10 && i !== 50
                )
            );
        }

        const category = new BDSliderFilterCategory();

        category.label = 'Minimale Druckgeschwindigkeit';
        category.title = 'Seiten pro Minute';
        category.distributeEvenly = true;
        category.fill = 'RTL';
        category.filters = filters;

        return category;
    }

    private initMFCMainFunctions(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('Farbdruck', 'funcColorPrint'));
        filters.push(new BDCheckboxFilter('Duplex-Druck', 'funcFax'));
        filters.push(new BDCheckboxFilter('Faxen', 'duplexPrint'));
        filters.push(new BDCheckboxFilter('Touch-Display', 'touchDisplay'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Hauptfunktionen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initMFCPorts(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('USB Anschluss', 'connections'));
        filters.push(new BDCheckboxFilter('WLAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('LAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('GIGABIT LAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('NFC', 'connections'));
        filters.push(new BDCheckboxFilter('Wi-Fi Direct', 'connections'));
        filters.push(new BDCheckboxFilter('Parallel Schnittstelle', 'connections'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Anschlussoptionen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initMFCPaperFormats(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('A3', 'printFormats'));
        filters.push(new BDCheckboxFilter('A4', 'printFormats'));
        filters.push(new BDCheckboxFilter('A5', 'printFormats'));
        filters.push(new BDCheckboxFilter('A6', 'printFormats'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Papierformate';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initMFCPaperFeedCount(): BDFilterCategory<BDRadioFilter> {
        const filters: BDRadioFilter[] = [];

        filters.push(new BDRadioFilter('1', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('2', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('3', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('4', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('5', 'minTotalPaperFeedNum'));
        filters.push(new BDRadioFilter('6', 'minTotalPaperFeedNum'));

        const category = new BDRadioFilterCategory();

        category.label = 'Anzahl Papierzufuhren';
        category.type = 'radio';
        category.filters = filters;

        return category;
    }

    private initMFCDailyScanVolume(): BDFilterCategory<BDSliderFilter> {
        const filters: BDSliderFilter[] = [];

        filters.push(new BDSliderFilter(150, 'minScanVolume', '150', '150'));
        filters.push(new BDSliderFilter(250, 'minScanVolume', '250', '250'));
        filters.push(new BDSliderFilter(300, 'minScanVolume', '300', '300'));
        filters.push(new BDSliderFilter(500, 'minScanVolume', '500', '500'));

        const category = new BDSliderFilterCategory();

        category.label = 'Tägliches Scanvolumen';
        category.title = 'Minimum';
        category.distributeEvenly = true;
        category.fill = 'RTL';
        category.filters = filters;

        return category;
    }

    private initMFCExtendedGuarantees(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('3 Jahre vor Ort', 'warrantyOnSite3Years'));
        filters.push(new BDCheckboxFilter('PrintAirBag', 'printAirbag'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Erweiterte Garantieleistungen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initMFCLanguage(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('PCL6 Emulation', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('PostScript', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('IBM ProMFC XL', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('Epson FX-850', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('XPS 1.0', 'printerLanguages'));
        filters.push(new BDCheckboxFilter('PDF 1.7', 'printerLanguages'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Druckersprache';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    //#endregion END MFC FILTERS

    //#region BEGIN LABELING DEVICE FILTERS

    private initLabelingDeviceCategory(name: string, imageSource: string): BDFilterDeviceCategory {
        const categories: BDFilterCategory<BDFilter>[] = [];

        const deviceCategory = new BDFilterDeviceCategory();

        deviceCategory.name = name;
        deviceCategory.internalName = 'labeler';
        deviceCategory.imageSource = imageSource;
        deviceCategory.filterCategories = categories;

        categories.push(this.initLabelingDeviceProductArea());
        categories.push(this.initLabelingDeviceLabelWidth());
        categories.push(this.initLabelingDeviceKeyboard());
        categories.push(this.initLabelingDevicePorts());
        categories.push(this.initLabelingDeviceFeatures());

        return deviceCategory;
    }

    private initLabelingDeviceProductArea(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('P-Touch', 'productDomain'));
        filters.push(new BDCheckboxFilter('QL', 'productDomain'));
        filters.push(new BDCheckboxFilter('TD', 'productDomain'));
        filters.push(new BDCheckboxFilter('VC', 'productDomain'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Produktbereicht';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }


    private getPercentage(value: number, start = 0.0672, end = 1, minValue = 3.5, maxValue = 106) {

        let fullRealLength = maxValue - minValue;
        let realValue = value - minValue;
        let percentage = realValue / fullRealLength;

        let convertToLength = end - start;

        return (convertToLength * percentage) + start;
    }

    private initLabelingDeviceLabelWidth(): BDFilterCategory<BDSliderFilter> {
        const filters: BDSliderFilter[] = [];

        filters.push(new BDSliderFilter(
            3.5,
            'labelWidth',
            '3.5',
            '3.5',
            0
        ));

        filters.push(new BDSliderFilter(
            6,
            'labelWidth',
            '6',
            '6',
            0
        ));

        filters.push(new BDSliderFilter(
            9,
            'labelWidth',
            '9',
            '9',
            0
        ));

        filters.push(new BDSliderFilter(
            12,
            'labelWidth',
            '12',
            '12',
            0
        ));

        filters.push(new BDSliderFilter(
            18,
            'labelWidth',
            '18',
            '18',
            -1
        ));

        filters.push(new BDSliderFilter(
            19,
            'labelWidth',
            '19',
            '19',
            1
        ));

        filters.push(new BDSliderFilter(
            24,
            'labelWidth',
            '24',
            '24',
            0
        ));

        filters.push(new BDSliderFilter(
            29,
            'labelWidth',
            '29',
            '29',
            0
        ));

        filters.push(new BDSliderFilter(
            38,
            'labelWidth',
            '38',
            '38',
            0
        ));

        filters.push(new BDSliderFilter(
            50,
            'labelWidth',
            '50',
            '50',
            -5
        ));

        filters.push(new BDSliderFilter(
            54,
            'labelWidth',
            '54',
            '54',
            -4
        ));

        filters.push(new BDSliderFilter(
            56,
            'labelWidth',
            '56',
            '56',
            -3
        ));

        filters.push(new BDSliderFilter(
            57, // value
            'labelWidth', // internal name
            '57', // legend
            '57', // label
            -1
        ));

        filters.push(new BDSliderFilter(
            58,
            'labelWidth',
            '58',
            '58',
            1
        ));

        filters.push(new BDSliderFilter(
            59,
            'labelWidth',
            ' 59',
            ' 59',
            3
        ));

        filters.push(new BDSliderFilter(
            60,
            'labelWidth',
            '60',
            '60',
            5
        ));

        filters.push(new BDSliderFilter(
            61,
            'labelWidth',
            '61',
            '61',
            7
        ));

        filters.push(new BDSliderFilter(
            62,
            'labelWidth',
            '62',
            '62',
            9
        ));

        filters.push(new BDSliderFilter(
            63,
            'labelWidth',
            '63',
            '63',
            11
        ));

        filters.push(new BDSliderFilter(
            102,
            'labelWidth',
            '102',
            '102',
            -16
        ));

        filters.push(new BDSliderFilter(
            103,
            'labelWidth',
            '103',
            '103',
            -12
        ));

        filters.push(new BDSliderFilter(
            104,
            'labelWidth',
            '104',
            '104',
            -8
        ));

        filters.push(new BDSliderFilter(
            105,
            'labelWidth',
            '105',
            '105',
            -4
        ));

        filters.push(new BDSliderFilter(
            106,
            'labelWidth',
            '106',
            '106',
            0
        ));

        filters.forEach(filter => {
            // console.log('filter position', filter.value,  filter.value + filter.percentage,  this.getPercentage(filter.value + filter.percentage) *100);

            // original percentage value is used as correction, value indicate where the label will be visible on x axe
            filter.percentage = this.getPercentage(filter.value + filter.percentage);
        });

        const category = new BDSliderFilterCategory();

        category.label = 'Labelbreite';
        category.title = 'mm';
        category.distributeEvenly = false;
        category.fill = 'NONE';
        category.filters = filters;
        category.displayPostfix = ' mm';

        return category;
    }


    private initLabelingDeviceKeyboard(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('ABC', 'keyboard'));
        filters.push(new BDCheckboxFilter('PC', 'keyboard'));
        filters.push(new BDCheckboxFilter('QWERTZ', 'keyboard'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Keyboard';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initLabelingDevicePorts(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('USB Anschluss', 'connections'));
        filters.push(new BDCheckboxFilter('WLAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('LAN Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('Bluetooth', 'connections'));
        filters.push(new BDCheckboxFilter('Parallel Schnittstelle', 'connections'));
        filters.push(new BDCheckboxFilter('Verbindung zu Tablet / Mobile', 'connections'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Anschlussoptionen';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    private initLabelingDeviceFeatures(): BDFilterCategory<BDCheckboxFilter> {
        const filters: BDCheckboxFilter[] = [];

        filters.push(new BDCheckboxFilter('Barcodedruck', 'printBarcode'));
        filters.push(new BDCheckboxFilter('Mobile Nutzung', 'mobileFunctions'));
        filters.push(new BDCheckboxFilter('Netzadapter inklusive', 'networkAdapterInclusive'));

        const category = new BDCheckboxFilterCategory();

        category.label = 'Features';
        category.type = 'checkbox';
        category.filters = filters;

        return category;
    }

    //#endregion

    //#region BEGIN FAX DEVICE FILTERS

    private initFaxDeviceCategory(name: string, imageSource: string): BDFilterDeviceCategory {
        const categories: BDFilterCategory<BDFilter>[] = [];

        const deviceCategory = new BDFilterDeviceCategory();

        deviceCategory.name = name;
        deviceCategory.internalName = 'fax';
        deviceCategory.portfolioName = 'Fax-Portfolio';
        deviceCategory.imageSource = imageSource;
        deviceCategory.filterCategories = categories;

        return deviceCategory;
    }

    //#endregion
}
